import { createFileRoute } from '@tanstack/react-router'

import { canonizarBuscaDoMapa, validarBuscaDoMapa } from '@/lib/camadaEmTeste'

import { ProvedorDoTooltipNoObservatorio } from '@/components/ajuda/Posicionamento'
import { Observatorio } from '@/components/layout/Observatorio'
import { ProvedorDaCamadaEmTeste } from '@/components/mapa/CamadaEmTeste'

/*
 * Página inicial do portal: o observatório — o mapa entre os painéis de camadas
 * e do imóvel. Filtros e ficha do imóvel chegam com os módulos que os servem.
 *
 * O recorte — filtros e busca — mora na URL desta rota, e quem reage a ele lê
 * e escreve por `useRecorte()`.
 *
 * É tela de mapa: o layout raiz tira o rodapé e dá ao observatório toda a
 * altura abaixo do cabeçalho.
 */
function Inicio() {
  return (
    <>
      <h1 className="sr-only">Observatório GEF Áreas Privadas — mapa do Valor de Conservação</h1>
      {/* A camada em teste, a prévia do arquivo e o tooltip que a gestão
          posiciona ou testa vêm dos parâmetros desta rota. */}
      <ProvedorDaCamadaEmTeste>
        <ProvedorDoTooltipNoObservatorio>
          <Observatorio />
        </ProvedorDoTooltipNoObservatorio>
      </ProvedorDaCamadaEmTeste>
    </>
  )
}

export const Route = createFileRoute('/')({
  staticData: { telaDeMapa: true },
  // O recorte: `bioma`, `uf`, `municipio`, `vcMin`, `vcMax` e `recibo`; a
  // camada que abre ligada, `camada` (o código do catálogo); e,
  // quando a Área do Gestor abre o observatório para testar uma camada,
  // `camadaEmTeste` ou `previaArquivo` com `cor`; para posicionar um tooltip,
  // `posicionarTooltip=true`, e para testá-lo, `tooltipEmTeste`. Valor sem
  // sentido some e valor padrão não fica na URL, sem erro.
  validateSearch: validarBuscaDoMapa,
  // E a URL fica só com isso: o link aberto com padrão ou lixo é reescrito, e
  // o modo de teste (da camada ou do tooltip) sobrevive aos filtros.
  search: { middlewares: [canonizarBuscaDoMapa] },
  component: Inicio,
})
